document.addEventListener('DOMContentLoaded', () => {
  eventButtons();
});

export function eventButtons() {
  const modal = document.querySelector('[js-quick-view]');
  
  if (modal) {
    const closeBtns = modal.querySelectorAll('[js-quick-view-closebtn]');
    closeBtns.forEach(closeBtn => {
      closeBtn.addEventListener('click', (e) => {
        e.preventDefault();
        modal.classList.remove('active');
        document.body.style.overflow = 'auto';
      })
    });
  }
}